export default __webpack_public_path__ + "static/media/productsImage.9c4c546b.jpg";